import { render } from "./Widget7.vue?vue&type=template&id=3fce2f87&ts=true"
import script from "./Widget7.vue?vue&type=script&lang=ts"
export * from "./Widget7.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__